"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateConnectProductSchema = exports.ProductService = void 0;
const zod_1 = require("zod");
var ProductService;
(function (ProductService) {
    ProductService["Collection"] = "COLLECTION";
    ProductService["CourtHandling"] = "COURT_HANDLING";
})(ProductService || (exports.ProductService = ProductService = {}));
exports.CreateConnectProductSchema = zod_1.z.object({
    partnerId: zod_1.z.string().uuid(),
    public: zod_1.z.boolean().optional(),
    name: zod_1.z.string(),
    logo: zod_1.z.string().uuid().optional(),
    description: zod_1.z.string(),
    content: zod_1.z.string(),
    billingModelId: zod_1.z.string().uuid().nullish(),
    workflowId: zod_1.z.string().uuid().nullish(),
    caseGroupId: zod_1.z.string().uuid().nullish(),
    service: zod_1.z.nativeEnum(ProductService),
});
//# sourceMappingURL=index.js.map